import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DebugLoggingService } from '../debug-logging.service';

@Component({
  selector: 'h3-flag-technical-issue-modal',
  templateUrl: './flag-technical-issue-modal.component.html',
  styleUrls: ['./flag-technical-issue-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FlagTechnicalIssueModalComponent {
  issueText = '';

  private debugLoggingService = inject(DebugLoggingService);

  flagIssue() {
    this.debugLoggingService.flagIssue(this.issueText);
  }
}
